<template>
  <div id="app" :class="bodyclass">
    <router-link
      class="button-light home-link inert-while-dialog-open"
      :to="{ name: 'shoppinglist', params: { key: sharelist } }"
      v-if="!previewMode && sharelist"
      tabindex="1"
      ><i class="icon-arrow-left" aria-hidden="true"></i
      ><span>Zurück zur Merkliste</span></router-link
    >
    <router-link
      class="button-light home-link inert-while-dialog-open"
      :to="{ name: 'home', params: { jump: true } }"
      v-if="!previewMode && !sharelist"
      tabindex="1"
      :aria-label="`Zurück zur Übersicht`"
      ><i class="icon-arrow-left" aria-hidden="true"></i
      ><span>Zurück zur Übersicht</span></router-link
    >
    
    <a
      href="https://www.rewe.de/"
      target="_blank"
      :class="`main-logo inert-while-dialog-open ${bodyclass} ${pageYOffset >= 5 ? 'mobile-logo' : ''}`"
      v-if="isPreview"
      title="Zu rewe.de"
      tabindex="2"
    ></a>
    <router-link
      :to="{ path: '/' }"
      :class="`main-logo inert-while-dialog-open ${bodyclass} ${pageYOffset >= 5 ? 'mobile-logo' : ''}`"
      v-else-if="loaded"
      title="Rewe Dein Markt, Zurück zur Startseite"
      tabindex="2"
    ></router-link>
    <transition name="from-top">
      <div class="mobile-nav-bg" v-if="pageYOffset >= 5"></div>
    </transition>
    <ShoppinglistButton class="inert-while-dialog-open" v-if="loaded && !previewMode && !sharelist && !isPreview" />
    <router-view
      :key="$route.path"
      v-if="loaded"
      @openVideo="openVideo"
      @setSharelist="setSharelist"
    />
    
    <ShoppinglistOverlay
      v-if="showShoppinglist && loaded && !previewMode && !isPreview"
    />
    <VideoOverlay
      v-if="showVideo && videoYoutubeId"
      :youtubeId="videoYoutubeId"
      @closeVideo="closeVideo"
    />
    <transition name="from-bottom">
      <div class="global-loading" v-if="loading" role="status" aria-live="polite">
        <img src="/assets/images/loading.gif" class="loading" alt="Daten werden geladen...">
      </div>
    </transition>
    <transition name="fade">
      <div class="intro-loading-container" v-if="!loaded" role="status" aria-live="polite">
        <img src="/assets/images/loading.gif" class="loading" alt="Daten werden geladen...">
        <p>Feuerwerk wird entzündet...</p>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ShoppinglistButton from "@/components/ShoppinglistButton.vue";
import ShoppinglistOverlay from "@/components/ShoppinglistOverlay.vue";
import VideoOverlay from "@/components/VideoOverlay.vue";
import throttle from "lodash.throttle";
export default {
  components: {
    ShoppinglistButton,
    ShoppinglistOverlay,
    VideoOverlay
  },
  metaInfo() {
    return {
      titleTemplate: `%s Feuerwerk: Alles für das ultimative Silvester - rewe.de`
    };
  },
  data() {
    return {
      loaded: false,
      pageYOffset: 0,
      videoYoutubeId: false,
      showVideo: false,
      sharelist: false
    };
  },

  created() {},
  mounted() {
    // if this is NOT the idle-state
    if (!this.$route.meta.preview) {
      this.$store.dispatch("storeShoppinglistSecret"); // must run before all shoppinglist calls

      const picsPromise = this.$store.dispatch("getPics");
      const copiesPromise = this.$store.dispatch("getCopies");
      const categoriesPromise = this.$store.dispatch("getCategories");
      const allProductsPromise = this.$store.dispatch("getAllProducts");

      const shoppinglistPromise = this.$store.dispatch(
        "getShoppinglistPrivate"
      );

      Promise.all([
        picsPromise,
        copiesPromise,
        categoriesPromise,
        allProductsPromise,
        shoppinglistPromise
      ]).then(() => {
        window.setTimeout(() => {
          this.loaded = true;
          setTimeout(function() {
            if (document.dispatchEvent) {
              document.dispatchEvent(new Event("x-app-rendered"));
            }
          }, 5000);
        }, 500);
      });
    } else {
      
      this.loaded = true;
      
      // as of 2024, we don't need to load the pics, copies and preview products, as we'll use the static ones
      // const picsPromise = this.$store.dispatch("getPics");
      // const copiesPromise = this.$store.dispatch("getCopies");
      // const previewProductsPromise = this.$store.dispatch("getPreviewProducts");
      
      // Promise.all([
      //   picsPromise,
      //   copiesPromise,
      //   previewProductsPromise
      // ]).then(() => {
      //   window.setTimeout(() => {
      //     this.loaded = true;
      //     setTimeout(function() {
      //       if (document.dispatchEvent) {
      //         document.dispatchEvent(new Event("x-app-rendered"));
      //       }
      //     }, 5000);
      //   }, 500);
      // });
      
    }
    window.addEventListener("scroll", this.onPageScroll);
  },
  methods: {
    setSharelist(sharelistKey) {
      this.sharelist = sharelistKey;
    },
    openVideo(youtubeId) {
      if (youtubeId) {
        this.$store.commit("SET_BODY_NO_OVERFLOW", true);
        this.$store.commit("SET_DIALOG_OPEN", true);
        this.videoYoutubeId = youtubeId;
        this.showVideo = true;
      }
    },
    closeVideo() {
      this.showVideo = false;
      this.videoYoutubeId = false;
      this.$store.commit("SET_BODY_NO_OVERFLOW", false);
      this.$store.commit("SET_DIALOG_OPEN", false);
    },
    onPageScroll: throttle(function() {
      this.pageYOffset = window.pageYOffset;
    }, 300)
  },
  watch: {
    showShoppinglist(newVal) {
      if (newVal) {
        this.$store.commit("SET_SHOW_SCROLLBAR", false);
        this.$store.commit("SET_DIALOG_OPEN", true);
      } else {
        this.$store.commit("SET_DIALOG_OPEN", false);
        if (this.$route.name !== "product") {
          this.$store.commit("SET_SHOW_SCROLLBAR", true);
        }
      }
    },
    showScrollbar(newVal) {
      if (newVal) {
        document
          .getElementsByTagName("body")[0]
          .classList.remove("hide-scrollbar");
      } else {
        document
          .getElementsByTagName("body")[0]
          .classList.add("hide-scrollbar");
      }
    },
    bodyNoOverflow(newVal) {
      if (newVal) {
        document.getElementsByTagName("body")[0].classList.add("no-overflow");
      } else {
        document
          .getElementsByTagName("body")[0]
          .classList.remove("no-overflow");
      }
    },
    dialogOpen(newVal) {
      const inertEls = document.querySelectorAll(".inert-while-dialog-open");
      if (newVal) {
        // add inert attribute to elements
        inertEls.forEach(el => el.setAttribute("inert", true));
      } else {
        // remove inert attribute from elements
        inertEls.forEach(el => el.removeAttribute("inert"));
      }
    }
  },
  computed: {
    ...mapState([
      "loading",
      "showScrollbar",
      "bodyNoOverflow",
      "showShoppinglist",
      "homeScrollPosition",
      "dialogOpen"
    ]),
    ...mapGetters(["isMobile"]),
    isPreview() {
      return (
        this.$route.name === "preview" || this.$route.name === "previewNext" || (this.$route.meta && this.$route.meta.preview)
      );
    },
    bodyclass() {
      return this.$route.name || "";
    },
    previewMode(){
      return this.$route.meta && this.$route.meta.preview === true
    }
  }
};
</script>

<style lang="scss">
@import "./scss/main";
</style>
